import themes from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React from 'react';
import { STATES, STATE_ACTIVE, STATE_NORMAL, StatefulIcon } from './styled';
export const Play = ({
  color,
  state
}) => /*#__PURE__*/React.createElement(StatefulIcon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "afspelen",
  viewBox: "0 0 64 64",
  state: state,
  color: color
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: STATE_NORMAL,
  d: "M13,9.76 C12.3785551,9.35048678 11.5776132,9.33258678 10.9384937,9.71392806 C10.2993743,10.0952693 9.9347482,10.8086249 10,11.55 L10,52.46 C9.93046856,53.203132 10.2934281,53.9202556 10.9334417,54.3042638 C11.5734554,54.688272 12.377016,54.6710605 13,54.26 L54.28,32.77 L54.28,32.77 L54.28,31.23 L13,9.76 Z M59.15,34.76 L11.51,59.54 C10.3591037,60.2000618 8.94200688,60.189518 7.80105961,59.5124041 C6.66011234,58.8352902 5.97197085,57.5964457 6,56.27 L6,7.73 C5.97197085,6.40355427 6.66011234,5.16470976 7.80105961,4.48759586 C8.94200688,3.81048196 10.3591037,3.79993825 11.51,4.46 L59.16,29.24 L59.16,29.24 C59.6610512,29.5076399 59.9812574,30.022257 60,30.59 L60,33.42 C59.9718613,33.9822821 59.6538182,34.4896364 59.16,34.76 L59.15,34.76 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  className: STATE_ACTIVE,
  d: "M59.16,34.76 L11.51,59.54 C10.3591037,60.2000618 8.94200688,60.189518 7.80105961,59.5124041 C6.66011234,58.8352902 5.97197085,57.5964457 6,56.27 L6,7.73 C5.97197085,6.40355427 6.66011234,5.16470976 7.80105961,4.48759586 C8.94200688,3.81048196 10.3591037,3.79993825 11.51,4.46 L59.16,29.24 L59.16,29.24 C59.6610512,29.5076399 59.9812574,30.022257 60,30.59 L60,33.42 C59.9718613,33.9822821 59.6538182,34.4896364 59.16,34.76 Z",
  fill: "currentColor"
})));
Play.propTypes = {
  color: PropTypes.string,
  state: PropTypes.oneOf(STATES)
};
Play.defaultProps = {
  color: themes.bnnvara.base.white,
  state: STATE_NORMAL
};